module.exports = __webpack_public_path__ + "static/media/cropIcon_Mustard.1ca1886e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/CropPageView/Catalog/Images/cropIcon_Mustard.png
// module id = 728
// module chunks = 0